import PostHeader from './PostHeader';

export default PostHeader;
